export default __webpack_public_path__ + "static/media/right_cursor_arrow.ebb6377c.svg";